import { type FC, type ReactNode } from "react";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";

import styles from "./GetStarted.module.scss";

type Step = {
  number: number;
  title: ReactNode;
  subSteps: ReactNode;
};

const steps: Step[] = [
  {
    number: 1,
    title: <FormattedMessage id="certifiedPage.getStarted.step1.title" />,
    subSteps: (
      <ul>
        <FormattedHTMLMessage id="certifiedPage.getStarted.step1.subSteps" />
      </ul>
    ),
  },
  {
    number: 2,
    title: <FormattedMessage id="certifiedPage.getStarted.step2.title" />,
    subSteps: (
      <ul>
        <FormattedHTMLMessage id="certifiedPage.getStarted.step2.subSteps" />
      </ul>
    ),
  },
  {
    number: 3,
    title: <FormattedMessage id="certifiedPage.getStarted.step3.title" />,
    subSteps: (
      <ul>
        <FormattedHTMLMessage id="certifiedPage.getStarted.step3.subSteps" />
      </ul>
    ),
  },
];

export const GetStarted: FC = () => {
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>
        <FormattedMessage id="certifiedPage.getStarted.title" />
      </h3>
      <ul className={styles.steps}>
        {steps.map((step) => (
          <GetStartedStep key={step.number} step={step} />
        ))}
      </ul>
    </div>
  );
};

const GetStartedStep = ({ step }: { step: Step }) => (
  <li className={styles.step}>
    <article>
      <span className={styles.stepNumber}>{step.number}</span>
      <h2 className={styles.stepTitle}>{step.title}</h2>
      {step.subSteps}
    </article>
  </li>
);
